import { useTranslation } from "react-i18next";
import { FormTextArea } from "@/shared/Components";
import type { Dispatch, SetStateAction } from "react";
import styles from "./styles.module.scss";

export const TextInput = ({ setText }: { setText?: Dispatch<SetStateAction<boolean>> }) => {
  const { t } = useTranslation();

  return (
    <FormTextArea
      autoSize
      name={"currentNote.text"}
      placeholder={t("common.inputText")}
      className={styles["note-textarea"]}
      onInput={() => setText && setText(true)}
    />
  );
};
